import { createContext } from "react"
import { MessageBrokerContextType } from "src/global/messageBroker/types"

export const MessageBrokerContext = createContext<MessageBrokerContextType | undefined>(undefined)
MessageBrokerContext.displayName = "MessageBrokerContext"
